'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordValidator = undefined;

var _reactIntl = require('react-intl');

var _verify = require('helpers/verify');

var PASSWORD_MIN_LENGTH = 8;
var MIN_COMPLEXITY_POINTS = 2;

var messages = (0, _reactIntl.defineMessages)({
  tooSimple: {
    id: 'validators.password.tooSimple',
    defaultMessage: 'Your password must have at least 8 characters, and include a number or symbol'
  }
});

var passwordValidator = exports.passwordValidator = function passwordValidator(val) {
  var str = ('' + val).trim();

  var complexityPoints = [/[a-zA-Z]/.test(str), /[0-9]/.test(str), /[^a-zA-Z0-9 ]/.test(str)].filter(function (x) {
    return x;
  }).length;

  if ((0, _verify.isBlank)(str) || str.length < PASSWORD_MIN_LENGTH || complexityPoints < MIN_COMPLEXITY_POINTS) {
    return messages.tooSimple;
  }
};